import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { PartialButton } from "~/providers/button-provider";

interface ButtonStoreState {
  selectedButton?: PartialButton;
  setSelectedButton: (button?: PartialButton) => void;
  buttonDialogOpen: boolean;
  setButtonDialogOpen: (open: boolean) => void;
}

export const useButtonStore = create<ButtonStoreState>()(
  devtools((set) => ({
    buttonDialogOpen: false,
    setButtonDialogOpen: (open) => {
      set(() => ({ buttonDialogOpen: open }));
    },
    setSelectedButton: (button) => {
      set(() => ({ selectedButton: button }));
    },
  })),
);
